import { useMemo } from 'react';

import { ProtocolName } from '../../constants/protocolNames';
import { useAppSelector } from '../../store';
import { TxBuilder } from '../update/types';
import { useBuildOneInchTx } from './useBuildOneInchTx';

export const useBuildSwapTx = (): TxBuilder => {
  const selectedProtocol = useAppSelector((state) => state.swap.selectedProtocol);
  const buildOneInchTx = useBuildOneInchTx();

  return useMemo(() => {
    const txBuilders = {
      [ProtocolName.ONE_INCH]: buildOneInchTx,
    };
    const txBuilder = txBuilders[selectedProtocol];

    if (!txBuilder) {
      throw new Error(`No tx builder for swap method: ${selectedProtocol}`);
    }

    return txBuilder;
  }, [selectedProtocol, buildOneInchTx]);
};
